import StarRankMobileThemeRankList from '@/components/starrank/mobile/StarRankMobileThemeRankList';
import StarRankMobileSwiperItem from '@/components/starrank/mobile/StarRankMobileSwiperItem';
import globalDomains, {globalAPPScheme} from '@/utils/global-domains';
import {useEffect} from 'react';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {SwiperSlide, Swiper} from 'swiper/react';
import globalNavigation from '@/utils/global-navigation';
import {StarrankT} from '@/utils/i18n/starrank';

/**
 * TODO
 * NOTE: 현재 별별랭킹 페이지는 (getDeviceType 체크로 분기 처리를 하는 코드 레벨) 적응형으로 구현되어
 * PC 버전에서 사용하는 컴포넌트와 모바일 버전에서 사용하는 컴포넌트가 달라집니다.
 * PC 버전에서 사용하는 컴포넌트의 경우 SOOP Kr 프로젝트의 공통 컴포넌트로 대부분 마이그레이션이 되었으나
 * 모바일 컴포넌트의 경우엔 애시당초 컴포넌트가 여기에 없어서 그렇게 하기 어려운 상황.
 * 그래서 분기 처리를 없애고 모바일 레이아웃을 지워버린 뒤 적응형에서 반응형으로 변경해야 한다고 생각하지만
 * 어디서부터 손을 대야 할 지는 고민해봐야 할 문제.
 */

// TODO 모바일 웹뷰 관련 유틸 함수들 모듈 분리하기

/**
 * 웹뷰 접속 여부를 확인하는 유틸함수
 */
export const isWebview = () => {
  const uagent = navigator.userAgent.toLocaleLowerCase();
  return uagent.indexOf('afreeca webview') > -1 ||
    uagent.indexOf('afreeca up webview') > -1 ||
    uagent.indexOf('sooplive webview') > -1 ||
    uagent.indexOf('sooplive up webview') > -1
    ? true
    : false;
};

/**
 * 웹뷰 여부를 판단해 APP_SCHEME 적용 후 방송으로 이동하도록 만드는 함수
 * @param {*} streamerId
 * @param {*} broadcastId
 */
export const goToLiveViaAppScheme = (streamerId, broadcastId) => {
  if (isWebview()) {
    window.location.href = `${globalAPPScheme}player/live?user_id=${streamerId}&broad_no=${broadcastId}`;
  } else {
    window.location.href = `${globalDomains.PLAY_AFREECATV}/${streamerId}/${broadcastId}`;
  }
};

/**
 * 웹뷰 여부를 판단해 APP_SCHEME 적용 후 방송국 페이지로 이동하도록 만드는 함수
 */
export const goToChannelViaAppScheme = (streamerId) => {
  if (isWebview()) {
    window.location.href = `${globalAPPScheme}browser/station?url=${globalDomains.BJ_AFREECATV}/${streamerId}`;
  } else {
    window.location.href = `${globalDomains.BJ_AFREECATV}/${streamerId}`;
  }
};

/**
 * 별별랭킹 모바일 레이아웃
 * @returns
 */
const StarRankMobileLayout = ({
  starRankBestData,
  starRankListData,
  starRankBestDataCnt,
  isLoading,
}) => {
  /**
   * 모바일 레이아웃 전용 상단 네비게이터의 뒤로가기 버튼 동작
   */
  const onBackClick = () => {
    window.history.back();
  };

  /**
   * 모바일 레이아웃에서 Soop Navigation 제거 및 이에 따른 여백 제거
   */
  useEffect(() => {
    const gnb = document.getElementById('soop-gnb');
    let navigationObserver = null;
    if (gnb) {
      // 비동기적인 GNB 렌더링 완료 여부 관찰해 제거
      navigationObserver = new MutationObserver(() => {
        const navInstance = globalNavigation.getNavigationInstance();
        if (navInstance) {
          navInstance.destroy();
          navigationObserver?.disconnect();
        }
      });

      navigationObserver.observe(gnb, {childList: true, subtree: true});
    }

    // 좌/상단 패딩 제거
    const main = document.getElementById('main');
    const soopWrap = document.getElementById('soop_wrap');
    main.style.paddingLeft = '0px';
    soopWrap.style.paddingTop = '0px';
    soopWrap.style.minWidth = '0';

    return () => {
      if (navigationObserver) {
        navigationObserver.disconnect();
      }
      globalNavigation.refresh();
    };
  }, []);

  return (
    <>
      {/* TODO: 모바일 화면에 대한 CSS 모듈 SOOPKr 프로젝트 내부로 이관 */}
      <link
        rel='stylesheet'
        type='text/css'
        href={`${globalDomains.RES_AFREECATV}/css/global/mobile/broad_ranking.css?t=231205`}
      />
      <div id='MobileWeb' className='broadRanking_wrap'>
        {!isWebview() ? (
          <header className='_header'>
            <div className='_header_innr'>
              <h2>{StarrankT('별별랭킹')}</h2>
              <button className='back' onClick={onBackClick}>
                {StarrankT('뒤로가기')}
              </button>
            </div>
          </header>
        ) : (
          <></>
        )}
        <div role='main' id='contents'>
          {starRankBestDataCnt > 0 ? (
            <>
              <div className='rank-stage'>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  initialSlide={0}
                  className='list-carousel'
                  wrapperTag='ul'
                  centeredSlides={true}
                  slidesPerView='auto'
                  loop={true}
                  loopAdditionalSlides={1}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    el: '.list-carousel .pagination',
                    clickable: true,
                  }}
                  onActiveIndexChange={(swiper) => {
                    if (isNaN(swiper.activeIndex)) {
                      swiper.slideTo(0);
                    }
                  }}>
                  {starRankBestData.map((item, index) => {
                    return (
                      <SwiperSlide
                        tag='li'
                        data-type='cBox'
                        role='group'
                        key={item.broadNo}>
                        <StarRankMobileSwiperItem broadItem={item} />
                      </SwiperSlide>
                    );
                  })}
                  <div className='pagination'></div>
                  <span
                    className='swiper-notification'
                    aria-live='assertive'
                    aria-atomic='true'></span>
                </Swiper>
              </div>
              {starRankListData.map((broadItem, index) => {
                return (
                  <StarRankMobileThemeRankList
                    broadItemList={broadItem}
                    key={`starrank-${index}`}
                  />
                );
              })}
            </>
          ) : (
            /* TODO: 데이터 없음 or 로딩 중 화면에 대한 스타일링 */
            <div
              style={{textAlign: 'center', opacity: !isLoading ? 100 : 0}}
              dangerouslySetInnerHTML={{
                __html: StarrankT(
                  `<h2>별별랭킹 데이터가 없습니다.</h2><br /><p>다음에 다시 이용해주세요.</p>`,
                ),
              }}></div>
          )}
        </div>
      </div>
    </>
  );
};

export default StarRankMobileLayout;
